export default __webpack_public_path__ + "assets/instagram-on.e6bac9cd.png";